import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { useHistory } from 'react-router-dom';
import CancelIcon from '@material-ui/icons/Cancel';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import SaveIcon from '@material-ui/icons/Save';
import ColorPicker from 'material-ui-color-picker'

import {
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Grid,
    Divider,
    Switch,
    TextField,
    Typography,
    colors
} from '@material-ui/core';

import { edit_showroom } from '../../../api/API';


const useStyles = makeStyles(theme => ({
    root: {},

    saveButton: {
        color: theme.palette.white,
        backgroundColor: colors.green[600],
        '&:hover': {
            backgroundColor: colors.green[900]
        },

    },

    leftIcon: {
        marginRight: theme.spacing.unit,
    },

    flexend: {
        justifyContent: 'flex-end',
    }
}));

export default function Form(props) {

    const { profile, className, ...rest } = props;

    const classes = useStyles();

    const [openSnackbar, setOpenSnackbar] = useState(false);

    const [values, setValues] = useState({
        ...props.showroom,
        require_showroom_unit: props.showroom.require_showroom_unit == "1" ? true : false,
        require_nationality: props.showroom.require_nationality == "1" ? true : false,
    });

    const handleColorChange = event => {
        console.log(event);
        setValues({
            ...values,
            color: event
        });
    }

    const history = useHistory();

    const positions = ['Superadmin', 'Admin'];

    const handleChange = event => {
        event.persist();

        setValues({
            ...values,
            [event.target.name]:
                event.target.type === 'checkbox'
                    ? event.target.checked
                    : event.target.value
        });
    };


    const handleSubmit = async event => {
        event.preventDefault();

        if (values.short_name.length > 3) {
            alert("Maxiumum 3 characters for short name");
            return;
        }

        let data = await edit_showroom(values);
        if (data) {
            history.push("/showroom/detailshowroom/" + values.property_id);
        }

    };

    const handleSnackbarClose = () => {
        setOpenSnackbar(false);
    };


    return (
        <Card
            {...rest}
            className={"edit_modal"}
        >
            <form onSubmit={handleSubmit}>
                <CardHeader title="Edit Showroom" />
                <Divider />
                <CardContent>
                    <Grid
                        container
                        spacing={4}
                    >

                        <Grid
                            item
                            md={6}
                            xs={12}
                        >
                            <TextField
                                fullWidth
                                label="Showroom"
                                name="name"
                                onChange={handleChange}
                                required
                                value={values.name}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid
                            item
                            md={6}
                            xs={12}
                        >
                            <TextField
                                fullWidth
                                label="Short Name"
                                name="short_name"
                                onChange={handleChange}
                                required
                                value={values.short_name}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid
                            item
                            md={6}
                            xs={12}
                        >
                            <TextField
                                fullWidth
                                label="Description"
                                name="description"
                                onChange={handleChange}
                                type="description"
                                value={values.description}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid
                            item
                            md={6}
                            xs={12}
                        >
                            <TextField
                                fullWidth
                                label="Max Pax Per Timeslot"
                                name="max_appointment"
                                onChange={handleChange}
                                type="number"
                                value={values.max_appointment}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid
                            item
                            md={6}
                            xs={12}
                        >
                            <TextField
                                fullWidth
                                label="Max Number of People Per Appointment"
                                name="max_pax"
                                onChange={handleChange}
                                type="number"
                                value={values.max_pax}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid
                                item
                                md={6}
                                xs={12}
                                style={{
                                    height: 250
                                }}
                            >
                                <div style={{
                                    display: 'flex',

                                }}>
                                    <div style={{
                                        minWidth: 54,
                                        maxWidth: 54,
                                        height: 54,
                                        borderRadius: 27,
                                        backgroundColor: values.color,
                                        marginRight: 10
                                    }}></div>
                                    <div
                                        style={{
                                            flexGrow: 1
                                        }}
                                    >
                                        <ColorPicker
                                            fullWidth
                                            label={values.color ? values.color : "-- select a color label --"}
                                            name="color"
                                            value={values.color}
                                            onChange={handleColorChange}
                                            variant="outlined"
                                        />
                                    </div>
                                </div>
                            </Grid>

                    </Grid>
                    <Grid
                        item
                        md={6}
                        xs={12}
                    >
                        <FormControl component="fieldset">
                            <FormGroup aria-label="position" row>
                                <FormControlLabel
                                    value="1"
                                    control={<Checkbox name="require_showroom_unit" color="primary" onChange={handleChange} />}
                                    label="Requires showroom unit? "
                                    labelPlacement="end"
                                    checked={values.require_showroom_unit == "1" ? true : false}
                                />
                            </FormGroup>
                        </FormControl>
                        <FormControl component="fieldset">
                            <FormGroup aria-label="position" row>
                                <FormControlLabel
                                    value="1"
                                    control={<Checkbox name="require_nationality" color="primary" onChange={handleChange} />}
                                    label="Requires guest nationality?"
                                    labelPlacement="end"
                                    checked={values.require_nationality == "1" ? true : false}
                                />
                            </FormGroup>
                        </FormControl>
                    </Grid>
                </CardContent>

                <Divider />
                <CardActions className={classes.flexend}>
                    <Button
                        variant="contained"
                        style={{
                            backgroundColor: "black"
                        }}
                        onClick={() => {
                            history.goBack();
                        }}
                    >
                        <CancelIcon className={classes.leftIcon} />
                        Cancel
                </Button>
                    <Button
                        className={classes}
                        type="submit"
                        variant="contained"

                    >
                        <SaveIcon className={classes.leftIcon} />
                        Save Changes
                </Button>
                </CardActions>
            </form>
            {/* <SuccessSnackbar
            onClose={handleSnackbarClose}
            open={openSnackbar}
            /> */}
        </Card>
    )
}

